export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const environment = process.env.NODE_ENV;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
export const CONTACT_NUMBER = '469-840-3990';
export const FLEET_CONTACT_NUMBER = '469-345-1639';
export const RETAIL_CONTACT_MESSAGE = 'Questions? Please email us at care@goodhood.auto & you will get a response within 24 hrs';
